
import { reactive, onMounted, defineComponent } from 'vue';
import Confirm from '@/components/confirm/confirm.vue'
import { getAdScheme, deleteAds } from '@/apis/ad'

import { ElMessage } from 'element-plus'
import { timeFormat } from '@/utils/format'
import i18n from "@/locales/index";
const _t = i18n.global.t;

export default defineComponent({
  components: { Confirm },
  setup() {
    const sortParams: { sort?: number } = { sort: -1 }
    const table = reactive({
      total: 0,
      page: 1,
      pageSize: 10,
      data: [] as any[],
    })

    const dialog = reactive({
      visiable: false,
      url: '',
      type: 'image',
      filename: '',
    })

    const formatPlayTime = (times: any[]) => {
      if (!Array.isArray(times)) return ''
      if (times.length === 1 && times[0].start_time === '00:00' && times[0].end_time === '00:00') {
        return _t('ad.allDay')
      }
      const result = times.map(item => `${item.start_time}~${item.end_time}`).filter(item => item !== '~')
      return result.join(', ')
    }

    const getTableList = () => {
      const { page, pageSize } = table
      getAdScheme({ page, pageSize, limit: true, status: -1, ...sortParams }).then((res: any) => {
        if (res.code === 200) {
          const { list, total } = res.data
          table.data = list
          table.total = total
        }
      })
    }

    const handleClose = () => {
      dialog.visiable = false
    }

    const handleDelete = (row: any) => {
      deleteAds(row.id).then((res: any) => {
        if (res.code === 200) {
          ElMessage.success(_t('ad.deleteSuccess'))
          getTableList()
        } else {
          ElMessage.error(res.msg)
        }
      })

    }

    const handlePageChange = (page: number) => {
      table.page = page
      getTableList()
    }

    const handleSizeChange = (pageSize: number) => {
      table.pageSize = pageSize
      table.page = 1
      getTableList()
    }

    const handleSortChange = (params: any) => {
      const { order, prop } = params
      if (prop === 'updated_at' && order === "ascending") sortParams.sort = 2
      if (prop === 'updated_at' && order === "descending") sortParams.sort = -2
      if (prop === "start_time" && order === "ascending") sortParams.sort = 1
      if (prop === "start_time" && order === "descending") sortParams.sort = -1
      if (!prop && !order) sortParams.sort = undefined
      getTableList()
    }

    onMounted(() => {
      getTableList()
    })

    return {
      table,
      dialog,
      formatPlayTime,
      handleClose,
      handleDelete,
      handlePageChange,
      handleSizeChange,
      timeFormat,
      handleSortChange,
    }
  }
})

